module.exports = __webpack_public_path__ + "static/img/qp0.cc15136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qp0.png
// module id = cG2Y
// module chunks = 2